import { withMscBellissimaCancelNotice } from '../../utils/mscBellissimaCancelNotice';

const MSC_LINE_ID = 16;
const NORWEGIAN_LINE_ID = 17;
const ROYAL_CARIBBEAN_LINE_ID = 22;
const DISNEY_LINE_ID = 73;

export const DEFAULT_TERMS = [
  {
    title: "특별 약관",
    description: "본 상품의 취소는 국외여행 표준약관 제16조 외에 약관 제6조에 의해 '국외여행 특별약관'이 적용됩니다. 특별약관은 표준약관보다 높은 취소료가 부과될 수 있으니 세부기준을 반드시 확인하셔야 합니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ],
    extra: {
      type: "link",
      text: "약관 상세 보기 >",
      url: "#"
    }
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      "출항~ 91일 전 취소 시(예약일~2월 28일): 위약금 없음",
      "출항 90일 ~ 61일 전 취소 시(3월 1일~3월 30일): 여행경비의 30%",
      "출항 60일 ~ 31일 전 취소 시(3월 31일~4월 29일): 여행경비의 50%",
      "출항 30일 ~ 출발 당일 취소 시(4월 30일 이후): 여행경비의 100%"
    ],
    extra: {
      type: "notes",
      notes: [
        "*취소 접수는 업무시간 내에 유선 접수만 가능합니다.",
        "*접수시간: 월~금 9:30~15:00, 토/일요일 공휴일 제외"
      ]
    }
  }
];

export const MSC_TERMS = [
  {
    title: "특별 약관",
    description: "※ MSC 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 MSC 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "label", text: "[벨라/판타스티카/아우레아 선실]" },
      "예약일 - 출발일 75일 전 : 무료",
      "출발일 74~60일 전: 1인당 USD $150",
      "출발일 59~50일 전: 1인당 USD $150 또는 총 요금의 25% 중 큰 요금",
      "출발일 49~30일 전: 1인당 USD $150 또는 총 요금의 50% 중 큰 요금",
      "출발일 29일 전 ~ 출발 당일: 총 요금의 100%",
      { type: "label", text: "(예외)MSC 벨리시마 부산 출도착", emphasis: true },
      { type: "label", text: "[벨라/판타스티카/아우레아 선실]" },
      "예약일 - 출발일 75일 전 : 총 요금의 5%",
      "출발일 74~60일 전: 1인당 USD $150",
      "출발일 59~50일 전: 1인당 USD $150 또는 총 요금의 25% 중 큰 요금",
      "출발일 49~30일 전: 1인당 USD $150 또는 총 요금의 50% 중 큰 요금",
      "출발일 29일 전 ~ 출발 당일: 총 요금의 100%",
      { type: "label", text: "[MSC 요트 클럽 선실]" },
      "예약일 - 출발일 120일 전 : 1인당 USD $100",
      "출발일 119일 - 90일 전 : 총 요금의 25%",
      "출발일 89일 - 60일 전 : 총 요금의 40%",
      "출발일 59일 - 30일 전 : 총 요금의 60%",
      "출발일 29일 - 15일 전 : 총 요금의 80%",
      "출발일 14일 - 출발 당일 : 총 요금의 100%",
      { type: "note", text: "※ 요트 클럽 등급 취소료 안내" },
      { type: "note", text: "요트 클럽은 무료 취소가 불가합니다." },
      { type: "note", text: "예약 시점부터 출발 120일 전까지 1인당 취소료 $100 발생합니다." },
      { type: "label", text: "[월드크루즈 2026년~]" },
      "출발일 91일 전 : 총 요금의 15%",
      "출발일 90일 - 11일 전 : 총 요금의 75%",
      "출발일 10일 - 출발 당일 : 총 요금의 100%"
    ],
    extra: {
      type: "notes",
      notes: [
        "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다."
      ]
    }
  }
];

export const NORWEGIAN_TERMS = [
  {
    title: "특별 약관",
    description: "※ 노르웨이지안 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 노르웨이지안 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "label", text: "[취소료 규정]" },
      "90일 전 : 무료",
      "89일 - 75 일 전 : 예약금 (총 요금의 20%)",
      "74일 - 50일 전 : 총 요금의 25%",
      "49일 - 29일 전 : 총 요금의 50%",
      "28일 - 15일 전 : 총 요금의 75%",
      "14일 - 출발일 : 총 요금의 100%",
      { type: "note", text: "※ BOGOFREE 프로모션(1번째 승객 요금 결제 시 2번째 승객은 무료, 단 세금은 별도 부담)의 경우, 지불된 예약금은 환불이 불가능합니다. 할인된 예약금(Reduced Deposit) 프로모션은 스위트(Suite) 및 헤이븐(Haven) 카테고리에는 적용되지 않습니다. 따라서 스위트 또는 헤이븐으로 업그레이드할 경우, 예약금 전액을 즉시 납부해야 합니다." },
      { type: "note", text: "※ 예약 확정 후 모든 변경 요청은 취소료 부과 이전 시점에만 가능하며, 취소료 부과 시점 이후에는 모든 예약 변경이 불가능합니다." },
      { type: "note", text: "※ 선실 요금의 25%, 50% 시점에 부과되는 취소료가 예약금보다 낮을 경우, 예약금이 취소료로 부과됩니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

export const ROYAL_CARIBBEAN_TERMS = [
  {
    title: "특별 약관",
    description: "※ 로얄캐리비안 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 로얄캐리비안 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "note", text: "로얄캐리비안 크루즈의 취소 규정은 크루즈 출항일과 일정 길이에 따라 다르게 적용됩니다." },
      { type: "note", text: "예약금은 상품 및 프로모션 조건에 따라 환불 불가(NRD)로 적용될 수 있습니다." },
      { type: "note", text: "예약 변경 또는 취소를 원하실 경우, 아래 규정을 반드시 확인해주시기 바랍니다." },
      { type: "label", text: "[1- 5박 일정]" },
      "75일 전: 무료 (단, 예약금 환불불가 조건은 1인당 USD 150)",
      "74 - 60일 : 예약금",
      "59 - 30일 : 총 요금의 50%",
      "29 - 15일 : 총 요금의 75%",
      "14 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[6박 - 9박 일정]" },
      "90일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 350)",
      "89 - 75일 : 예약금",
      "74 - 45일 : 총 요금의 50%",
      "44 - 15일 : 총 요금의 75%",
      "14 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[10박 - 14박 일정]" },
      "90일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 500)",
      "89 - 75일 : 예약금",
      "74 - 61일 : 총 요금의 50%",
      "60 - 31일 : 총 요금의 75%",
      "30 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[15박 이상 일정]" },
      "121일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 500)",
      "120 - 61일 : 총 요금의 25%",
      "60 - 41일 : 총 요금의 50%",
      "40 - 25일 : 총 요금의 75%",
      "24 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[예약금 안내]" },
      { type: "note", text: "*1~5박: 1인당 USD 150" },
      { type: "note", text: "*6~9박: 1인당 USD 350" },
      { type: "note", text: "*10박 이상: 1인당 USD 500" },
      { type: "note", text: "*스위트: 크루즈 요금의 10% 또는 위 금액 중 큰 금액" },
      { type: "note", text: "*아이콘호 STAR 등급: 1인당 USD 600" },
      { type: "note", text: "※ 예약금 환불 불가(NRD) 조건으로 예약하신 경우, 결제하신 예약금은 환불되지 않습니다." },
      { type: "note", text: "※ 선실 요금의 25%, 50% 시점에 부과되는 취소료가 예약금보다 낮을 경우, 예약금 금액이 취소료로 부과됩니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

export const DISNEY_TERMS = [
  {
    title: "특별 약관",
    description: "※ 디즈니 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 디즈니 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "label", text: "[1- 5박 일정]" },
      { type: "label", text: "*내측 / 오션뷰 / 베란다" },
      "예약일 - 90일 전 : 무료",
      "89일 - 45일 전 : 예약금 (총 요금의 10%)",
      "44일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "*컨시어지 / 스위트" },
      "예약일 - 45일 전 : 예약금 (총 요금의 10%)",
      "44일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "[6박 이상 일정]" },
      { type: "label", text: "*내측 / 오션뷰 / 베란다" },
      "예약일 - 120일 전 : 무료",
      "119일 - 56일 전 : 예약금 (총 요금의 10%)",
      "55일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "*컨시어지 / 스위트" },
      "예약일 - 56일 전 : 예약금 (총 요금의 10%)",
      "55일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "note", text: "※ 인사이드 개런티, 오션뷰 개런티, 베란다 개런티 등급으로 예약 시, 크루즈 요금은 100% 환불 불가합니다." },
      { type: "note", text: "예약 확정을 위한 예약금은 크루즈 요금의 10%입니다." },
      { type: "note", text: "※ 예약 후 모든 변경이 불가능하며, 예약 규정에 따라 취소료가 발생합니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

export const resolveTermsByLineId = (lineId, context = {}, options = {}) => {
  const numericLineId = Number(lineId);
  if (numericLineId === MSC_LINE_ID) {
    return withMscBellissimaCancelNotice(MSC_TERMS, { ...context, lineId: numericLineId }, options);
  }
  if (numericLineId === NORWEGIAN_LINE_ID) return NORWEGIAN_TERMS;
  if (numericLineId === ROYAL_CARIBBEAN_LINE_ID) return ROYAL_CARIBBEAN_TERMS;
  if (numericLineId === DISNEY_LINE_ID) return DISNEY_TERMS;
  return DEFAULT_TERMS;
};
